<script>
  import { _ } from "svelte-i18n";
  
  export let session = {};
  const elements = [
    {
      group: "Hopp",
      id: "jump.salchow",
      label: "Salchow",
      name: "S",
    },
    {
      group: "Hopp",
      id: "jump.loop",
      label: "Slynge",
      name: "Lo",
    },
    {
      group: "Hopp",
      id: "jump.flip",
      label: "Flip",
      name: "F",
    },
    {
      group: "Hopp",
      id: "jump.toeloop",
      label: "Toe loop",
      name: "T",
    },
    {
      group: "Hopp",
      id: "jump.lutz",
      label: "Lutz",
      name: "Lz",
    },
    {
      group: "Hopp",
      id: "jump.axel",
      label: "Axel",
      name: "A",
    },
    {
      group: "Hopp",
      id: "jump.combination",
      label: "Kombinasjonshopp",
    },
    {
      group: "Piruett",
      id: "spinn.upright",
      label: "Ståpiruett",
      name: "USp",
    },
    {
      group: "Piruett",
      id: "spinn.sit",
      label: "Kork",
      name: "SSp",
    },
    {
      group: "Piruett",
      id: "spinn.camel",
      label: "Parallell",
    },
    {
      group: "Piruett",
      id: "spinn.jump",
      label: "Hoppe-parallell",
    },
    {
      group: "Piruett",
      id: "spinn.layback",
      label: "Bøyepiruett",
      name: "LSp",
    },
    {
      group: "Piruett",
      id: "spinn.combination",
      label: "Kombinasjonspiruett",
      name: "CoSp",
    },
    {
      group: "Konkurransetrening",
      id: "competition.shortProgram",
      label: "Kortprogram (SP)",
    },
    {
      group: "Konkurransetrening",
      id: "competition.freeProgram",
      label: "Friprogram (FP)",
    },
    {
      group: "Konkurransetrening",
      id: "competition.otherCompetition",
      label: "Annen konkurranserelatert trening",
    },
    {
      group: "Annen istrening",
      id: "stepSequence",
      label: "Trinnsekvens",
      name: "StSq",
    },
    {
      group: "Annen istrening",
      id: "choreoSequence",
      label: "Koreografisk sekvens",
      name: "ChSq",
    },
    {
      group: "Annen istrening",
      id: "FigureSkating.TechniqueSteps",
      label: "Trinntrening",
      name: "StSq",
    },
    {
      group: "Annen istrening",
      id: "FigureSkating.flyer",
      label: "Flyver",
    },
    {
      group: "Annen istrening",
      id: "FigureSkating.BaseTraining",
      label: "Oppvarming på is",
    },
    {
      group: "Islek",
      id: "general.game1",
      label: "Kalosjlek",
    },
    {
      group: "Islek",
      id: "general.game2",
      label: "Annen lek",
    },
    {
      group: "Bevegelighet",
      id: "mobility",
      label: "Bevegelighet og tøying",
    },
    {
      group: "Styrke",
      id: "strength",
      label: "Styrke, spenst og hurtighet",
    },
  ];
</script>

<div style="margin-bottom:35px">
  <b
    >{session.name ? session.name : "(uten navn)"}, {new Date(
      session.date
    ).toLocaleDateString("no-NB", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    })}</b
  ><br />
  <div style="margin-left:15px">
    Hoveddel
    <div style="margin-left:15px; display:grid; grid-template-columns: 4fr 1fr">
      {#each session.main as entry}
        <div style="display:grid-row">
          {#if entry.type === "strength"}
            {#if entry.focus}
              {$_("sessions.form.strength." + entry.focus)} - {$_("sessions.form.strength." + entry.method)}
            {:else}
              {$_("sessions.form.strength." + entry.method)}
            {/if}
          {:else if elements.find((item) => item.id === entry.element) !== undefined}
            {elements.find((item) => item.id === entry.element).group} / {elements.find(
              (item) => item.id === entry.element
            ).label}
            {#if elements.find((item) => item.id === entry.element).name !== undefined}
              <span>
                ({elements.find((item) => item.id === entry.element)
                  .name})</span
              >
            {/if}
            {#if entry.repetitions || entry.success}
              <span>
                #{#if entry.successful}<span>{entry.successful}/</span
                  >{/if}{entry.repetitions}
              </span>
            {/if}
          {:else}
            {JSON.stringify(entry)}
          {/if}
        </div>
        <div style="text-align: right">
          {#if entry.duration}
            {entry.duration} min
          {/if}
        </div>
      {/each}
      <div
        style="display:grid-row; border-top: solid 1px black; font-weight:bold"
      >
        Totalt
      </div>
      <div
        style="text-align: right; border-top: solid 1px black; font-weight:bold"
      >
        {session.main.reduce(
          (sum, entry) => sum + (entry.duration ? parseInt(entry.duration) : 0),
          0
        )}
        min
      </div>
    </div>
    <div style="padding-top:10px">
      <i>{session.comments}</i>
    </div>

    <pre style="display:none;font-color:grey;font-size:10pt">
        {JSON.stringify(session, null, 2)}
    </pre>
  </div>
</div>
